import { Box, Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import React, { ReactNode } from "react"

type Props = {
  title: string
  iconName: string
  children: ReactNode
  iconColor: string
}

const SidebarBlock = ({
  title, iconName, children, iconColor,
}: Props) => (
  <Box mb={10}>
    <Flex alignItems="center">
      <Icon icon={iconName} mr={2} size={7} color={iconColor} />
      <Text fontWeight="bold" fontSize="xl" color="gray.700" lineHeight={1.1}>
        {title}
      </Text>
    </Flex>
    <Box ml={10} mt={4}>
      {children}
    </Box>
  </Box>
)

export default SidebarBlock
